import { policyRoutePaths } from './paths';

import type { RouteObject } from 'react-router-dom';

export const policyRoute: RouteObject[] = [
  {
    path: policyRoutePaths.privacyPolicy.path,
    async lazy() {
      const PrivacyPolicyPage = await import('@/pages/policy/PrivacyPolicy');
      return { Component: PrivacyPolicyPage.default };
    },
  },
  // TRAD-2249 — 이용약관. 원래 authRoute(AuthLayout)에 있어 푸터·헤더 없는 화면이었다.
  // 같은 성격의 정책 문서인 privacy-policy 와 같은 그룹으로 맞춘다(둘 다 푸터에서 링크된다).
  {
    path: policyRoutePaths.terms.path,
    async lazy() {
      const TermsPage = await import('@/pages/policy/Terms');
      return { Component: TermsPage.default };
    },
  },
  {
    path: policyRoutePaths.houseRule.path,
    async lazy() {
      const HouseRulePage = await import('@/pages/policy/HouseRule');
      return { Component: HouseRulePage.default };
    },
  },
  {
    path: policyRoutePaths.support.path,
    async lazy() {
      const SupportPage = await import('@/pages/support/SupportPage');
      return { Component: SupportPage.default };
    },
  },
];
